import { createContext, useState } from "react";

export type MenuContextType = {
  toggle: boolean;
  setMenuToggle: (bol:boolean) => void;
};

export const MenuContext = createContext<MenuContextType | null>(null);

const MenuContextProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [toggle, setToggle] = useState(false);
  const setMenuToggle = (bol:boolean) => {
    setToggle(bol);
  }
  return (
    <MenuContext.Provider value={{ toggle, setMenuToggle }}>{children}</MenuContext.Provider>
  );
};

export default MenuContextProvider;
